import React, {useEffect, useMemo, useState} from "react";
import {Badge} from "antd";
import BookCover from "@components/book-cover";
import {WishlistGridItemProps} from "@mwPages/my-collection/wishlist/WishlistGridItem";
import {useWishlistRemoveIssueMutation} from "@mwServices/User";
import {showResponse} from "@services/Api";
import AddComicModal from "@components/add-comic-modal";
import moment from "moment";
import WishlistListItemDesktop from "@mwPages/my-collection/wishlist/WishlistListItemDesktop";
import WishlistListItemMobile from "@mwPages/my-collection/wishlist/WishlistListItemMobile";
import {WishlistEditDrawer} from "@components/wishlist-edit-drawer";

const WishlistListItem = ({
                              item,
                              onIssueUpdate,
                              showEditMultiple,
                              isSelected,
                              toggleSelected,
                              searchCollection,
                              showDesktopView,
                              showValueRibbon,
                              windowDimensions
}: WishlistGridItemProps) => {
    const [wishlistIssueRemove, removeWishlistResponse] = useWishlistRemoveIssueMutation();
    const [addIssueId, setAddIssueId] = useState(null);
    const [showEdit, setShowEdit] = useState(false);
    const issueDate = useMemo(() => { return moment(item.date.split(' ').shift()).toDate(); }, [item]);

    useEffect(() => {
        if (removeWishlistResponse.isSuccess && onIssueUpdate) onIssueUpdate({ ...item, in_wishlist: false });
        showResponse(removeWishlistResponse, 'Issue removed from wishlist.', 'Failed to remove issue from wishlist.');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [removeWishlistResponse]);

    const bookCover = useMemo(() => (<BookCover issue={item} className="list-book-cover" />),[item]);

    return (
        <>
            {showDesktopView ? (
                <WishlistListItemDesktop
                    item={item}
                    showEditMultiple={showEditMultiple}
                    isSelected={isSelected}
                    toggleSelected={toggleSelected}
                    bookCover={bookCover}
                    searchCollection={searchCollection}
                    issueDate={issueDate}
                    showValueRibbon={showValueRibbon}
                    setShowEdit={setShowEdit}
                    setAddIssueId={setAddIssueId}
                    wishlistIssueRemove={wishlistIssueRemove}
                    windowDimensions={windowDimensions}
                />
            ) : (
                <WishlistListItemMobile
                    item={item}
                    showEditMultiple={showEditMultiple}
                    isSelected={isSelected}
                    toggleSelected={toggleSelected}
                    bookCover={bookCover}
                    issueDate={issueDate}
                    showValueRibbon={showValueRibbon}
                    setShowEdit={setShowEdit}
                    setAddIssueId={setAddIssueId}
                    wishlistIssueRemove={wishlistIssueRemove}
                    windowDimensions={windowDimensions}
                />
            )}

            {addIssueId && (
                <AddComicModal isModalOpen={true} issueIds={[addIssueId]} onCancel={() => setAddIssueId(null)}
                               onIssueUpdate={onIssueUpdate}/>
            )}

            <WishlistEditDrawer visible={showEdit} issue={item} onClose={() => setShowEdit(false)}/>
        </>
    );

};

export default WishlistListItem;